import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=5e21cd9e&scoped=true&"
import script from "./declare.vue?vue&type=script&lang=js&"
export * from "./declare.vue?vue&type=script&lang=js&"
import style0 from "./declare.vue?vue&type=style&index=0&id=5e21cd9e&prod&lang=scss&scoped=true&"
import style1 from "./declare.vue?vue&type=style&index=1&id=5e21cd9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e21cd9e",
  null
  
)

export default component.exports